import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/rankmyai.webp';
import screenshot_target from '../../../images/letterfunnel/jesseweltevreden.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jesse Weltevreden"
      firstname="Jesse"
      companyname="RankMyAI"
      competition="Futurepedia en TAAFT"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jesseweltevreden.js